export enum InfoType {
  STANDBY = 'STANDBY',
  STANDSTILL = 'STANDSTILL',
  MOVING = 'MOVING',
  NO_DATA = 'NO_DATA',
  ETA = 'ETA',
  ETA_LATE = 'ETA-LATE',
  ETA_ON_TIME = 'ETA-ON-TIME',
  WAITING = 'WAITING',
  REMAIN = 'REMAIN',
  HANDOVER = 'HANDOVER',
  HANDOVER_RELEASE = 'RELEASED',
  HANDOVER_TAKE = 'TAKEN',
  CHECKIN = 'CHECKIN',
  CHECKOUT = 'CHECKOUT',
  HELP = 'HELP',
  END = 'END',
  END_TRIP = 'END_TRIP',
  OVERVIEW = 'OVERVIEW'
}
